import React, { useState, useEffect } from "react";
import styles from "./qs.module.css";
import myImage from "./markimage.jpg";

// Speaker images
import maitrayeeImg from "../../assets/speakers_imgs/maitrayee.jpeg";
import harinieImg from "../../assets/speakers_imgs/harinie.jpeg";
import bhavnaImg from "../../assets/speakers_imgs/bhavna.jpeg";
import abhijeetImg from "../../assets/speakers_imgs/abhijeet.jpeg";
import sairamImg from "../../assets/speakers_imgs/sairam.jpeg";
import triguneshImg from "../../assets/speakers_imgs/trigunesh.jpeg";
import sparshImg from "../../assets/speakers_imgs/sparsh.png";
import salmaanImg from "../../assets/speakers_imgs/salmaan.jpeg";

function Q() {

  const speakers = [
    { id: 0, name: "Dr. Maittrayee Patar", img: maitrayeeImg },
    { id: 1, name: "Ms. Harinie Jeevitha", img: harinieImg },
    { id: 2, name: "Ms. Bhavna Harchandrai", img: bhavnaImg },
    { id: 3, name: "Mr. Abhijeet Anand", img: abhijeetImg },
    { id: 4, name: "Dr. Sairam Atluri", img: sairamImg },
    { id: 5, name: "Mr. Trigunesh Mukherjee", img: triguneshImg },
    { id: 6, name: "Dr. Sparsh Johari", img: sparshImg },
    { id: 7, name: "Mr. Salmaan Ahmed", img: salmaanImg }
  ];

  const [startIndex, setStartIndex] = useState(0);
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);
  const [question, setQuestion] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [visibleCount, setVisibleCount] = useState(3);

  useEffect(() => {
    const updateVisibleCount = () => {
      const isMobile = window.innerWidth <= 768;
      const isPortrait = window.matchMedia("(orientation: portrait)").matches;

      if (isMobile && isPortrait) {
        setVisibleCount(1);
      } else {
        setVisibleCount(3);
      }
    };

    updateVisibleCount();
    window.addEventListener("resize", updateVisibleCount);

    return () => window.removeEventListener("resize", updateVisibleCount);
  }, []);

  const visibleSpeakers = speakers.slice(
    startIndex,
    startIndex + visibleCount
  );

  const next = () => {
    if (startIndex + visibleCount < speakers.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const prev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const submitHandler = () => {
    if (!selectedSpeaker || question.trim() === "") {
      alert("Please select a speaker and type a question.");
      return;
    }

    const GOOGLE_FORM_URL =
      "https://docs.google.com/forms/d/1Rvr03Uyd_L99dugsPexm7LG3w078p7vkQMeFoeokqao/formResponse";

    const formData = new FormData();
    formData.append("entry.1618045074", selectedSpeaker);
    formData.append("entry.104691745", question);

    fetch(GOOGLE_FORM_URL, {
      method: "POST",
      mode: "no-cors",
      body: formData,
    })
      .then(() => {
        setSubmitted(true);
      })
      .catch((error) => {
        console.error("Submission error:", error);
        alert("Something went wrong. Please try again.");
      });
  };

  if (submitted) {
    return (
      <div className={styles.page}>
        <div className={styles.successBox}>
          <h1>Question Submitted Successfully!</h1>
          <p>
            Thank you for participating. Your question has been submitted and
            will be addressed by the speaker.
          </p>

          <button
            className={`${styles.primaryBtn} ${styles.centerBtn}`}
            onClick={() => {
              setSubmitted(false);
              setQuestion("");
              setSelectedSpeaker(null);
              setStartIndex(0);
            }}
          >
            Submit Another Question
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.page}>

      <div className={styles.hero}>
        <div className={styles.heroCircle}>
          <img src={myImage} alt="TED" />
        </div>

        <div className={styles.heroText}>
          <h1>Couldn't Attend? Ask Your Question Here.</h1>
          <p>
            This official portal ensures non-attendees have their questions
            heard. Submit now and our speakers will address the most impactful
            ones during the talk.
          </p>
        </div>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Select Speaker</h2>

        <div className={styles.carousel}>
          <button className={styles.arrow} onClick={prev}>
            &lt;
          </button>

          <div className={styles["speaker-grid"]}>
            {visibleSpeakers.map((speaker) => (
              <div
                key={speaker.id}
                className={`${styles.speakerCard} ${
                  selectedSpeaker === speaker.name ? styles.active : ""
                }`}
                onClick={() => setSelectedSpeaker(speaker.name)}
              >
                <img
                  src={speaker.img}
                  alt={speaker.name}
                  className={styles.speakerImage}
                />

                <span className={styles.speakerName}>
                  {speaker.name}
                </span>
              </div>
            ))}
          </div>

          <button className={styles.arrow} onClick={next}>
            &gt;
          </button>
        </div>
      </div>

      <div className={styles.section}>
        <h2 className={styles.sectionTitle}>Your Question</h2>

        <textarea
        className={styles.text}
          placeholder="Enter your question here..."
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
        />

        <button
          className={`${styles.primaryBtn} ${styles.centerBtn}`}
          onClick={submitHandler}
        >
          Submit Question
        </button>
      </div>
    </div>
  );
}

export default Q;
